/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type DevopsConnectionsSettingsType from '@jira/spa-apps__project-settings-connections/src/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyDevOpsConnectionsSettings: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof DevopsConnectionsSettingsType
>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-devops-connections", jiraSpaEntry: "async-project-settings-devops-connections" */ '@jira/spa-apps__project-settings-connections/src/index.tsx'
		),
);

const AsyncDevOpsConnectionsSettings = (): React.JSX.Element => (
	<LazyPage
		Page={LazyDevOpsConnectionsSettings}
		pageId="devops-connections-settings"
		shouldShowSpinner={false}
	/>
);

export default AsyncDevOpsConnectionsSettings;
